/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rename_Product_DescriptionInputs */

const en_rename_product_description = /** @type {(inputs: Rename_Product_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product description`)
};

const de_rename_product_description = /** @type {(inputs: Rename_Product_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktbeschreibung`)
};

/**
* | output |
* | --- |
* | "Product description" |
*
* @param {Rename_Product_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_product_description = /** @type {((inputs?: Rename_Product_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Product_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_product_description(inputs)
	return en_rename_product_description(inputs)
});